import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)

const state = {
    addAppData:[],
};
const mutations = {
    SET_APP_DATA(state, userData) {
        console.log("userData",userData);
        state.addAppData = userData;
    },
    ADD_EDIT_APP_DATA(state, userData) {
        if(userData.AppCreation.app_type=="admin"){
            console.log('Data : ', userData);
        console.log('dats : ', state.addAppData.adminappData);
        var index = state.addAppData.adminappData.findIndex(data => 
            data.AppCreation.id == userData.AppCreation.id
        );
        console.log('index : ', index);
        
        if(index != -1){
            state.addAppData.adminappData.splice(index,1,userData);

        } else {
            state.addAppData.adminappData.push(userData);
        }
        console.log('state : ', state.addAppData.adminappData);
        }else{
            console.log('Data : ', userData);
        console.log('dats : ', state.addAppData.customerappData);
        var index = state.addAppData.customerappData.findIndex(data => 
            data.AppCreation.id == userData.AppCreation.id
        );
        console.log('index : ', index);
        
        if(index != -1){
            state.addAppData.customerappData.splice(index,1,userData);

        } else {
            state.addAppData.customerappData.push(userData);
        }
        console.log('state : ', state.addAppData.customerappData);
        }
        // console.log('Data : ', userData);
        // console.log('dats : ', state.addAppData.appData);
        // var index = state.addAppData.appData.findIndex(data => 
        //     data.AppCreation.id == userData.AppCreation.id
        // );
        // console.log('index : ', index);
        
        // if(index != -1){
        //     state.addAppData.appData.splice(index,1,userData);

        // } else {
        //     state.addAppData.appData.push(userData);
        // }
        // console.log('state : ', state.addAppData.appData);
      },
      DELETE_APP_DATA(state, outdata) {
        console.log("ad",outdata);
        console.log("ad",state.addAppData.adminappData);
        if(outdata.type=="admin"){
            console.log("ad",outdata.id);
            console.log("ad",state.addAppData.adminappData);
            var index = state.addAppData.adminappData.findIndex(data => data.AppCreation.id == outdata.id);
            state.addAppData.adminappData.splice(index, 1);
        }else{
            var index = state.addAppData.customerappData.findIndex(data => data.AppCreation.id == outdata.id);
            state.addAppData.customerappData.splice(index, 1);
        }
    },
};
const actions = {
    newAppDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("AppCreation/add_app_details", postData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    console.log("postData",postData);
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('ADD_EDIT_APP_DATA', response.data.responseData);
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    fetchAppData({
        commit,
    }) {
        Nprogress.start()
        axios.get('AppCreation/get_app_details')
            .then(res => {
                console.log(res);
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    
                    commit('SET_APP_DATA', res.data.data);
                }
            })
            .catch(error => console.log(error))
    },
    
    saveAppDetailsStatus({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios
                .post("AppCreation/updateStatus", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    console.log(response);
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    previewDetail({
        commit,
        dispatch
    },postData) {
        console.log(postData);
        return new Promise((resolve, reject) => {
            axios
                .post("AppCreation/previewDetails", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    console.log(response);
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    createCustomerApp({
        commit,
        dispatch
    },postData) {
        console.log(postData);
        return new Promise((resolve, reject) => {
            axios
                .post("AppCreation/createCustomerApp", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    console.log(response);
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    deleteAppDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("AppCreation/deleteDetails", qs.stringify(postData, {
                    parseArrays: false
                }))
                .then(response => {
                    loader.hide();
                    console.log(response);
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }else{
                        commit('DELETE_APP_DATA', response.data.data);
                    }
                    resolve(response.data);

                })
                .catch(error => console.log(error));
        });
    },
    
};

const getters = {
    appDataGetter: state => {
        return state.addAppData;
    },
};
export default {
    state,
    mutations,
    actions,
    getters
}